import { render } from "./MyCollapse.vue?vue&type=template&id=7fb8444c"
import script from "./MyCollapse.vue?vue&type=script&lang=js"
export * from "./MyCollapse.vue?vue&type=script&lang=js"

import "./MyCollapse.vue?vue&type=style&index=0&id=7fb8444c&noscoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__